import { useCallback } from 'react';
import axios from 'axios';
import { webframeApi } from 'api/webframeApi';
import { useEnvironment, useHttp } from '@publicisgroupe/p-os-components';
import { SharepointEntities } from 'utils/enums';
import { CookieBannerDto, SharepointCookieBannerDto } from '../types';

const getLatestCookieData = (cookieData: CookieBannerDto[]) => {
  return cookieData.reduce((prev: CookieBannerDto, current: CookieBannerDto) =>
    prev.versionNumber > current.versionNumber ? prev : current
  );
};

const getLatestSharepointCookieData = (cookieData: SharepointCookieBannerDto[]) => {
  return cookieData.reduce((prev: SharepointCookieBannerDto, current: SharepointCookieBannerDto) =>
    prev.VersionNumber > current.VersionNumber ? prev : current
  );
};

const fetchFromWebframeApi = async (http: any) => {
  const response = await webframeApi(http)?.getCookieConfig();

  return response?.data.data;
};

const fetchFromSharePointApi = async (env: any) => {
  const response = await axios.get<{ value: SharepointCookieBannerDto[] }>(
    `${env.settings.apiBaseURL}/mock/list?entity=${SharepointEntities.Cookie}`,
    {
      headers: {
        'Ocp-Apim-Subscription-Key': env.settings.ocpApimKey,
      },
    }
  );

  return response?.data?.value;
};

const transformCookieSharepointResponse = (
  cookieData: SharepointCookieBannerDto | undefined
): CookieBannerDto | undefined => {
  if (!cookieData) return;

  return {
    title: cookieData.Title,
    shortText: cookieData.ShortText,
    longText: cookieData.LongText,
    versionNumber: cookieData.VersionNumber,
    canViewInLogin: cookieData.CanViewInLogin,
    icon: cookieData.Icon,
  };
};

export const useCookieData = () => {
  const http = useHttp();
  const env = useEnvironment();

  return useCallback(
    async (useConfigModule: boolean) => {
      if (useConfigModule) {
        const responseCookieData = await fetchFromWebframeApi(http);

        if (!responseCookieData || responseCookieData.length === 0) return;

        return getLatestCookieData(responseCookieData);
      } else {
        const responseCookieData = await fetchFromSharePointApi(env);

        if (!responseCookieData || responseCookieData.length === 0) return;

        const latestData = getLatestSharepointCookieData(responseCookieData);
        const transformedData = transformCookieSharepointResponse(latestData);

        return transformedData;
      }
    },
    [http, env]
  );
};
